import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstadisticaService {

  private static readonly DELAY_MS = 6000; // 6 segundos mínimo para contar como visita
  private pendingVisits: Map<string, any> = new Map();

  constructor(private httpClient: HttpClient) { }

  /**
   * Registra una visita después de un delay de 3 segundos.
   * Si el usuario navega fuera antes de los 3 segundos, la visita no se registra.
   */
  registrarVisita(activoId: string, tipoCategoria: string): void {
    const key = `${activoId}-${tipoCategoria}`;

    // Cancelar visita pendiente anterior para el mismo activo (evita duplicados por F5)
    if (this.pendingVisits.has(key)) {
      clearTimeout(this.pendingVisits.get(key));
    }

    const timeoutId = setTimeout(() => {
      this.pendingVisits.delete(key);
      const url = `${environment.urlBase}${environment.registrarVisita}`;
      const body = { activoId: Number(activoId), tipoCategoria: tipoCategoria };
      this.httpClient.post(url, body).pipe(
        catchError((error) => {
          console.error('[ESTADISTICA] Error:', error);
          return EMPTY;
        })
      ).subscribe();
    }, EstadisticaService.DELAY_MS);

    this.pendingVisits.set(key, timeoutId);
  }

  /**
   * Cancela una visita pendiente (llamar en ngOnDestroy del componente).
   */
  cancelarVisita(activoId: string, tipoCategoria: string): void {
    const key = `${activoId}-${tipoCategoria}`;
    if (this.pendingVisits.has(key)) {
      clearTimeout(this.pendingVisits.get(key));
      this.pendingVisits.delete(key);
    }
  }
}
